import PersonIcon from '@mui/icons-material/Person'
import { Typography } from '@mui/material'
import { differenceInMinutes, formatDistanceStrict, parseISO } from 'date-fns'
import { enUS, fr, nl } from 'date-fns/locale'
import { ReferenceField, useLocaleState, useRecordContext, useTranslate, WithRecord } from 'react-admin'

import FieldRow from './FieldRow'
import { formatDateTime } from '../../utils/dates'
import CircularGaugeIcon from '../CircularGaugeIcon'

const localeMap = { en: enUS, fr, nl }
const CurrentBookingField = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  const [locale] = useLocaleState()

  return (
    <ReferenceField
      reference="bookings"
      source="booking_id"
      empty={
        <FieldRow icon={<CircularGaugeIcon Icon={PersonIcon} />}>
          <Typography variant="body2" color="black">
            {translate('resources.bookings.noOngoingBooking')}
          </Typography>
        </FieldRow>
      }
    >
      <WithRecord
        render={(booking) => {
          const scheduledEnd = parseISO(booking.end_scheduled_on)
          const captured = parseISO(record.captured_on)
          const diffMinutes = differenceInMinutes(captured, scheduledEnd)

          const formattedBookingBounds = `${formatDateTime(booking.start_scheduled_on)} -> ${formatDateTime(
            booking.end_scheduled_on,
          )}`
          const endedAgo = formatDistanceStrict(captured, scheduledEnd, { locale: localeMap[locale] })

          const value = diffMinutes <= 0 ? 0 : diffMinutes < 60 ? 1 : 2
          return (
            <FieldRow
              icon={
                <CircularGaugeIcon
                  Icon={PersonIcon}
                  thresholds={[
                    {
                      limit: 0.5,
                      color: '#1fd92e',
                      label: {
                        message: 'booking.runningOnSchedule',
                        options: { schedule: `${formattedBookingBounds}` },
                      },
                    },
                    { limit: 1.5, color: '#ed6c02', label: { message: 'booking.endedAgo', options: { endedAgo } } },
                    {
                      limit: Infinity,
                      color: '#d32f2f',
                      label: { message: 'booking.endedAgo', options: { endedAgo } },
                    },
                  ]}
                  value={value}
                />
              }
            >
              <ReferenceField reference="users" source="user_id" />
            </FieldRow>
          )
        }}
      />
    </ReferenceField>
  )
}

export default CurrentBookingField
